import { IS_SELECTION_REVEALED_CHANGED, INIT_ROOT } from '../actionTypes';

export default (state, { type, payload }) => {
  if (type === INIT_ROOT) {
    return payload.isSelectionRevealed;
  }
  if (type === IS_SELECTION_REVEALED_CHANGED) {
    return payload;
  }
  return state || false;
};
